import React from "react";
import SignIn from "../components/signin";
function Login(props) {
  return (
    <>
      <SignIn />
    </>
  );
}
export default Login;